export default "__VITE_ASSET__Cn_Sa7Ra__"